import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Glyphicon, Tooltip } from 'react-bootstrap';
import _ from 'underscore';
import { titleize, humanize } from 'underscore.string';
import moment from 'moment';

import { getDisplayAction } from 'utils/formatters/stops';
import Node from 'components/modules/shipments/stops/Node';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { showToast } from 'stores/ToastStore';

import AddAppointmentModal from 'components/ui/tailwind/modals/AddAppointmentModal';
import {
  getLocationTimezone,
} from 'helpers/locations';

import RemoveStopModal from './RemoveStopModal';
import AddContactModal from './AddContactModal';

import AddEquipmentModal from './AddEquipmentModal';
import EditStopLocationModal from './EditStopLocationModal';
import { withTranslation, Translation } from 'react-i18next';
import { sluggify } from '../../../utils/localization/utils';

const FORMAT = 'YYYY-MM-DD hh:mm a';
const DATE_FORMAT = 'YYYY-MM-DD';

const TOOLTIPS = {
  late: (
    <Tooltip id="late-tooltip">
      <Translation>{(t) => t('SCHEDULE_DATE_PASTED_TIP')}</Translation>
    </Tooltip>
  ),
  sameday: (
    <Tooltip id="sameday-tooltip">
      <Translation>{(t) => t('SCHEDULE_TODAY_TIP')}</Translation>
    </Tooltip>
  ),
};
const CargomaticDatePicker = (props) => {
  return (
    <button onClick={props.onClick} className="button-secondary">
      <span>{props.message}</span>
      <Glyphicon glyph="time" className="ml-2 text-green" />
    </button>
  );
};

CargomaticDatePicker.propTypes = {
  onClick: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
};

class StagingStop extends Component {
  static propTypes = {
    timezone: PropTypes.string,
    selected_timezone: PropTypes.string,
    shipment: PropTypes.shape({
      shipment_type: PropTypes.string,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      showRemoveModal: false,
      showContactModal: false,
      showAddAppointmentModal: false,
      showEquipmentModal: false,
      showEditStopModal: false,
    };
  }

  removeStop = () => {
    this.props.removeStop(this.props.idx);
  };

  addContact = (data) => {
    const { stop } = this.props;
    stop.contacts = [...(stop.contacts || []), data];
    this.setState({ showContactModal: false }, () => {
      this.props.onEdit(stop);
    });
  };

  convertDateToTimezone(date, timezone) {
    return moment(date)
      .tz(timezone, false)
      .format();
  }
  componentDidMount() {
    const { stop, t } = this.props
    const action = getDisplayAction(stop)
    if (!!!stop.location) {
      showToast(
        t('STOP_MISSING_LOCATION', { action }),
        t('STOP_MISSING_LOCATION', { action }),
        'error',
      );
    }
  }

  handleAppointmentChange = (appointment) => {
    const { stop } = this.props;

    // The Four basic steps
    // TODO: Create a moment static class to handle these manipulations
    // ******
    // 1) Create a moment object
    // 2) Set the TZ in the moment to the users selected timezones
    // 3) Move the update the moment to the correct timezone by formatting
    // 4) Offset to the shipment timezones
    // ****

    // get a moment representing the current time
    const appointment_start = moment(appointment.start);
    const appointment_end = moment(appointment.end);
    // create a new moment based on the original one -- this allows us to shift timezones WITHOUT changing time
    const appointment_start_clone = appointment_start.clone();
    const appointment_end_clone = appointment_end.clone();

    // This COULD be refactored to the AppointmentPicker component but let's not (yet)
    // change the time zone of the new moment with the user selected timezone
    appointment_start_clone.tz(this.props.selected_timezone, true);
    appointment_end_clone.tz(this.props.selected_timezone, true);

    // And finally we convert the timezone to the timezone the user selected
    const s_timezone = this.convertDateToTimezone(
      appointment_start_clone,
      this.props.timezone,
    );
    const e_timezone = this.convertDateToTimezone(
      appointment_end_clone,
      this.props.timezone,
    );

    // Finally we have to offset to the timezone of the shipment
    const astart = moment(s_timezone)
      .tz(this.props.timezone)
      .format();
    const estart = moment(e_timezone)
      .tz(this.props.timezone)
      .format();

    stop.window_start = astart;
    stop.window_end = estart;
    stop.appointment = true;
    this.setState({ showAddAppointmentModal: false }, () => {
      this.props.onEdit(stop);
    });
  };

  handleEquipmentSelect = (equipment) => {
    if (
      this.props.stop.equipments &&
      this.props.stop.equipments.map(eq => eq._id).includes(equipment._id)
    ) {
      return;
    }
    const stopToEdit = this.props.stop;
    const equipments = stopToEdit.equipments || [];
    stopToEdit.equipments = [...equipments, equipment];
    this.props.onEdit(stopToEdit, { message: 'add', equipment });
  };

  handleRemoveEquipment = (equipment) => {
    const stopToEdit = this.props.stop;
    const equipments = _.without(stopToEdit.equipments, equipment.id);
    stopToEdit.equipments = equipments;
    this.props.onEdit(stopToEdit, {
      message: 'remove',
      equipment: { _id: equipment.id },
    });
  };

  handleAppointmentClear(stop) {
    stop.window_start = moment(stop.window_start).startOf('day');
    stop.window_end = moment(stop.window_start).endOf('day');
    stop.appointment = false;
    this.props.onEdit(stop);
  }

  handleDateChange = (date) => {
    const { stop } = this.props;
    stop.window_start = moment(date).startOf('day');
    stop.window_end = moment(date).endOf('day');
    stop.appointment = false;
    this.props.onEdit(stop);
  };

  handleEditStop(stop) {
    this.setState({ showEditStopModal: false }, () => {
      this.props.onEdit(stop);
    });
  }

  handleCreateEquipment = (equipment) => {
    const {
      onCreateStopEquipment,
      stop: {
        sequence,
      },
    } = this.props;
    onCreateStopEquipment(sequence, equipment);
  }

  handleEquipmentRemove(equipment) {
    const { stop } = this.props;

    stop.equipments = stop.equipments
      .filter(eq => eq.equipment_id !== equipment.equipment_id);

    this.props.onEdit(stop);
  }

  handleRemoveContact(index) {
    const { stop: currentStop } = this.props;
    const stopContacts = currentStop.contacts || [];

    const stop = {
      ...currentStop,
      contacts: [
        ...stopContacts.slice(0, index),
        ...stopContacts.slice(index + 1),
      ],
    };

    this.props.onEdit(stop);
  }

  renderAppointmentSelector() {
    const { t } = this.props;
    return (
      <div className="text-grey-darker">
        <button
          onClick={() => this.setState({ showAddAppointmentModal: true })}
          className="py-2 button-secondary"
        >
          <Glyphicon glyph="plus-sign" />
          <span className="ml-2">{t('APPOINTMENT')}</span>
        </button>
      </div>
    );
  }

  renderEquipment(equipment) {
    return (
      <div
        key={equipment._id}
        className="flex mb-2"
      >
        <div className="w-1/3 text-grey-darker">{equipment.equipment_id}</div>
        <div className="w-1/3 text-grey-darker">{equipment._equipmentType}</div>
        <div className="w-1/3 text-green">
          <button
            className="button-secondary"
            onClick={() => this.handleEquipmentRemove(equipment)}
          >
            <Glyphicon glyph="remove" className="ml-2 text-sm text-grey" />
          </button>
        </div>
      </div>
    );
  }

  renderEquipments() {
    const { stop, t } = this.props;

    if (stop.equipments && stop.equipments.length > 0) {
      return (
        <div>
          <div className="flex text-grey-darker font-semibold mb-2 border-solid border-b">
            <div className="w-1/3 justify-center">{t('EQUIPMENT')}</div>
            <div className="w-1/3 justify-center">{t('TYPE')}</div>
            <div className="w-1/3 justify-center">{titleize(t('REMOVE'))}</div>
          </div>

          {stop.equipments.map((equipment, i) => {
            return this.renderEquipment(equipment, i);
          })}
          <div className="inline-flex">
            <div className="text-grey-darker">
              <button
                className="button button-green"
                onClick={() => this.setState({ showEquipmentModal: true })}
              >
                <Glyphicon glyph="plus" className="mr-2" />
                <span>{t('EQUIPMENT')}</span>
              </button>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div>
        <div className="h-6">&nbsp;</div>
        <div className="inline-flex">
          <div className="">
            <button
              className="button button-green"
              onClick={() => this.setState({ showEquipmentModal: true })}
            >
              <Glyphicon glyph="plus" className="mr-2" />
              {t('EQUIPMENT')}
            </button>
          </div>
        </div>
      </div>
    );
  }

  renderDatePicker() {
    const { stop, t } = this.props;
    let color = '';
    let past = false;

    if (stop.window_start && moment(stop.window_start).isBefore(moment())) {
      if (moment(stop.window_start).diff(moment(), 'days') === 0) {
        color = 'orange';
      } else {
        color = 'red';
      }
      past = true;
    }

    if (stop.window_start && stop.window_end && stop.appointment) {
      let timezone = getLocationTimezone(stop.location);

      if (!timezone) {
        timezone = moment.tz(this.props.timezone).zoneAbbr();
      }
      return (
        <div>
          <div style={{ color }}>
            <div>{`${moment(stop.window_start).format(FORMAT)}`} -</div>
            <div>
              {`${moment(stop.window_end).format(FORMAT)} (${timezone})`}
              {past && (
                <OverlayTrigger
                  placement="top"
                  overlay={color === 'red' ? TOOLTIPS.late : TOOLTIPS.sameday}
                >
                  <Glyphicon glyph="info-sign" className="pl-2" />
                </OverlayTrigger>
              )}
            </div>
          </div>
          <div className="inline-flex">
            <div className="text-green mr-4">
              <button
                className="py-2 button-secondary"
                onClick={() => this.setState({ showAddAppointmentModal: true })}
              >
                <span>{t('EDIT')}</span>
                <Glyphicon glyph="time" className="ml-2" />
              </button>
            </div>
            <div className="text-grey-darker">
              <button
                onClick={() => this.handleAppointmentClear(stop)}
                className="py-2 button-secondary"
              >
                <span>{t('CLEAR')}</span>
                <Glyphicon glyph="time" className="ml-2" />
              </button>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div>
        <div className="h-6" style={{ color }}>
          {stop.window_start && moment(stop.window_start).format(DATE_FORMAT)}
          {past && (
            <OverlayTrigger
              placement="top"
              overlay={color === 'red' ? TOOLTIPS.late : TOOLTIPS.sameday}
            >
              <Glyphicon glyph="info-sign" className="pl-2" />
            </OverlayTrigger>
          )}
        </div>
        <div className="inline-flex">
          <div className="text-green mr-4 pt-2">
            <DatePicker
              customInput={
                <CargomaticDatePicker
                  message={!stop.window_start ? t('SELECT') : t('EDIT')}
                />
              }
              selected={this.state.startDate}
              onChange={this.handleDateChange}
            />
          </div>
          <div>{this.renderAppointmentSelector()}</div>
        </div>
      </div>
    );
  }

  render() {
    const { stop, t } = this.props;
    const action = getDisplayAction(stop);

    const { window_start: start, window_end: end } = stop;

    let startDate;
    let endDate;

    if (start && moment(start).isValid()) {
      startDate = start;
    }

    if (end && moment(end).isValid()) {
      endDate = end;
    }

    return (
      <div className="sortable mb-3">
        <div className="pt-2 pb-6 bg-white shadow">
          <div className="flex">
            <div style={{ width: '10%' }}>
              <div className="p-6">
                <Node
                  color="#38495C"
                  sequence={stop.sequence}
                  lastStop
                />
              </div>
            </div>
            <div style={{ width: '10%' }}>
              <div className="pt-8 text-grey-darker font-semibold">
                {titleize(t(sluggify(action)))}
                <button
                  className="font-normal text-green pl-2 py-2 button-secondary"
                  onClick={() => this.setState({ showEditStopModal: true })}
                >
                  <Glyphicon glyph="edit" className="mr-2" />
                </button>
              </div>
            </div>
            <div className="w-1/4">
              <div className="pt-8">
                <div className="text-grey-darker font-semibold">
                  {stop?.location?.name || ''}
                  <button
                    className="font-normal text-green pl-2 py-2 button-secondary"
                    onClick={() => this.setState({ showEditStopModal: true })}
                  >
                    <Glyphicon glyph="edit" className="mr-2" />
                  </button>
                </div>
                <div>{stop?.location?.address || ''}</div>
                <div>
                  {stop.contacts && stop.contacts.length > 0 && (
                    <div className="pt-2 font-semibold text-grey-darker">
                      {t('CONTACT', { count: 2 })}
                      <button
                        className="font-normal text-green pl-2 py-2 button-secondary"
                        onClick={() =>
                          this.setState({ showEditStopModal: true })
                        }
                      >
                        <Glyphicon glyph="edit" className="mr-2" />
                      </button>
                    </div>
                  )}
                  {stop.contacts && stop.contacts.length === 0 && (
                    <div className="text-grey-darker">
                      <button
                        className="font-normal text-green py-2 button-secondary"
                        onClick={() =>
                          this.setState({ showEditStopModal: true })
                        }
                      >
                        <Glyphicon glyph="plus" className="pr-2" />
                      </button>
                      {t('CONTACT', { count: 1 })}
                    </div>
                  )}
                  {stop.contacts &&
                    stop.contacts.length > 0 &&
                    stop.contacts.map((contact, i) => {
                      return (
                        <div className="pb-2" key={i}>
                          <div className="italic">
                            {titleize(contact.name)}
                            <button
                              className="button-secondary"
                              onClick={() => this.handleRemoveContact(i)}
                            >
                              <Glyphicon
                                glyph="remove"
                                className="ml-2 text-xs text-grey"
                              />
                            </button>
                          </div>
                          <div>
                            {contact.phone}, {contact.email}
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
            <div className="w-1/6">
              <div className="pt-8">{this.renderDatePicker()}</div>
            </div>
            <div className="w-1/3">
              <div className="pt-8 pr-4">{this.renderEquipments()}</div>
            </div>
            <div style={{ width: '2%' }} className="text-grey">
              <div className="mt-4">
                <button
                  className="button-secondary"
                  onClick={() => this.setState({ showRemoveModal: true })}
                >
                  <Glyphicon glyph="remove" />
                </button>
              </div>
            </div>
          </div>
        </div>

        {this.state.showRemoveModal && (
          <RemoveStopModal
            show={this.state.showRemoveModal}
            onClose={() => this.setState({ showRemoveModal: false })}
            removeStop={this.removeStop}
          />
        )}
        {this.state.showContactModal && (
          <AddContactModal
            show={this.state.showContactModal}
            onClose={() => this.setState({ showContactModal: false })}
            addContact={this.addContact}
          />
        )}
        {this.state.showAddAppointmentModal && (
          <AddAppointmentModal
            shipment={this.props.shipment}
            stop={this.props.stop}
            show={this.state.showAddAppointmentModal}
            timezone={this.props.timezone}
            selected_timezone={this.props.selected_timezone}
            onSave={this.handleAppointmentChange}
            onHide={() => this.setState({ showAddAppointmentModal: false })}
          />
        )}
        {this.state.showEquipmentModal && (
          <AddEquipmentModal
            show={this.state.showEquipmentModal}
            onClose={() => this.setState({ showEquipmentModal: false })}
            onEquipmentSelect={this.handleEquipmentSelect}
            orderEquipment={this.props.order.equipments || []}
            onCreateEquipment={this.handleCreateEquipment}
          />
        )}
        {this.state.showEditStopModal && (
          <EditStopLocationModal
            onClose={() => this.setState({ showEditStopModal: false })}
            onSave={s => this.handleEditStop(s)}
            stop={stop}
          />
        )}
      </div>
    );
  }
}

StagingStop.propTypes = {
  stop: PropTypes.object,
  order: PropTypes.object,
  idx: PropTypes.number,
  onEdit: PropTypes.func.isRequired,
  removeStop: PropTypes.func.isRequired,
  onCreateStopEquipment: PropTypes.func.isRequired,
};

export default  withTranslation()(StagingStop); 